import { motion, type MotionStyle } from "motion/react";
import cx from "classnames";
import { BUN_PUBLIC_IMAGE_BASE_URL } from "@/env.json";

const socials = {
  Github: {
    icon: BUN_PUBLIC_IMAGE_BASE_URL + "/icons/github.svg",
    href: "https://github.com/Axiver",
  },
  LinkedIn: {
    icon: BUN_PUBLIC_IMAGE_BASE_URL + "/icons/linkedin.svg",
    href: "https://www.linkedin.com/in/xavierteozk/",
  },
};

export type SocialPlatforms = keyof typeof socials;

export function SocialLink({ platform, style, href }: { platform: SocialPlatforms; style?: MotionStyle; href?: string }) {
  return (
    <motion.a className={cx("shadow-lg size-12 md:size-16 rounded-full")} style={style} href={href ?? socials[platform].href} target='_blank'>
      <img src={socials[platform].icon} alt={`${platform} icon`} className='h-full rounded-full' />
    </motion.a>
  );
}
